import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex" };
const _hoisted_2 = { class: "w-100" };
const _hoisted_3 = ["href"];
const _hoisted_4 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Download = _resolveComponent("Download");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_table_column = _resolveComponent("el-table-column");
    const _component_radio_button_form = _resolveComponent("radio-button-form");
    const _component_el_radio = _resolveComponent("el-radio");
    const _component_el_table = _resolveComponent("el-table");
    const _component_el_checkbox = _resolveComponent("el-checkbox");
    const _component_label_form = _resolveComponent("label-form");
    const _component_el_card = _resolveComponent("el-card");
    return (_openBlock(), _createBlock(_component_el_card, {
        shadow: "never",
        "body-style": { padding: 0 },
        class: "border-0"
    }, {
        default: _withCtx(() => {
            var _a;
            return [
                _createVNode(_component_el_table, {
                    data: _ctx.modelRelevantEvidenceFields,
                    class: "mb-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                            label: "Dokumen Portfolio",
                            width: "auto",
                            "min-width": "300"
                        }, {
                            default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("p", _hoisted_2, _toDisplayString(scope.row.label), 1 /* TEXT */),
                                    _createElementVNode("a", {
                                        href: scope.row.file,
                                        target: "_blank",
                                        class: "ms-4 text-primary"
                                    }, [
                                        _createVNode(_component_el_icon, { class: "text-extra-large" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_Download)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ], 8 /* PROPS */, _hoisted_3)
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_el_table_column, {
                            label: "Valid",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                    label: "Ya",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isValid,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isValid) = $event),
                                                options: [{ label: null, value: true }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isValid`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_el_table_column, {
                                    label: "Tidak",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isValid,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isValid) = $event),
                                                options: [{ label: null, value: false }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isValid`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_el_table_column, {
                            label: "Asli",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                    label: "Ya",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isOriginal,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isOriginal) = $event),
                                                options: [{ label: null, value: true }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isOriginal`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_el_table_column, {
                                    label: "Tidak",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isOriginal,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isOriginal) = $event),
                                                options: [{ label: null, value: false }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isOriginal`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_el_table_column, {
                            label: "Terkini",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                    label: "Ya",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isLatest,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isLatest) = $event),
                                                options: [{ label: null, value: true }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isLatest`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_el_table_column, {
                                    label: "Tidak",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isLatest,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isLatest) = $event),
                                                options: [{ label: null, value: false }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isLatest`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_el_table_column, {
                            label: "Memadai",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                    label: "Ya",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isWorthy,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isWorthy) = $event),
                                                options: [{ label: null, value: true }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isWorthy`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_el_table_column, {
                                    label: "Tidak",
                                    align: "center"
                                }, {
                                    default: _withCtx((scope) => [
                                        (_ctx.isAssessment)
                                            ? (_openBlock(), _createBlock(_component_radio_button_form, {
                                                key: 0,
                                                modelValue: _ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isWorthy,
                                                "onUpdate:modelValue": ($event) => ((_ctx.modelRelevantEvidenceFields[_ctx.findIndexRelevantEvidenceFields(scope.row)].isWorthy) = $event),
                                                options: [{ label: null, value: false }],
                                                borderless: "",
                                                disabled: _ctx.disabled,
                                                center: "",
                                                rules: [_ctx.validationRequired()],
                                                prop: `fields.${_ctx.order}.relevantEvidenceFields.${_ctx.findIndexRelevantEvidenceFields(scope.row)}.isWorthy`
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disabled", "rules", "prop"]))
                                            : (_openBlock(), _createBlock(_component_el_radio, {
                                                key: 1,
                                                disabled: _ctx.disabled
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(null))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["disabled"]))
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["data"]),
                _createVNode(_component_el_table, {
                    data: (_a = _ctx.competencyUnit.statements) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerTypeId === _ctx.answerTypeId),
                    "scrollbar-always-on": true,
                    "default-expand-all": ""
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(((_a = _ctx.competencyUnit.customAnswerFields) === null || _a === void 0 ? void 0 : _a.filter((item) => item.answerType.id === _ctx.answerTypeId)) || [], (item, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                    (item.answerField.type === 'checkbox')
                                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                                            key: 0,
                                            label: item.label,
                                            align: "center"
                                        }, {
                                            default: _withCtx((scope) => [
                                                (_ctx.isAssessment)
                                                    ? (_openBlock(), _createBlock(_component_label_form, { key: 0 }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_el_checkbox, {
                                                                modelValue: _ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                                    .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                                    .statementAnswerFields].value,
                                                                "onUpdate:modelValue": ($event) => ((_ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                                    .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                                    .statementAnswerFields].value) = $event),
                                                                label: true,
                                                                disabled: _ctx.disabled,
                                                                checked: _ctx.modelStatementFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                                    .statementFields].statementAnswerFields[_ctx.foundStatementIndex(scope.row.id, item.answerField.id)
                                                                    .statementAnswerFields].value === 'true'
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(null))
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "disabled", "checked"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */))
                                                    : (_openBlock(), _createBlock(_component_el_checkbox, {
                                                        key: 1,
                                                        disabled: _ctx.disabled
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(null))
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["disabled"]))
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label"]))
                                        : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */));
                            }), 128 /* KEYED_FRAGMENT */)),
                            _createVNode(_component_el_table_column, {
                                label: "No. Elemen",
                                width: "100"
                            }, {
                                default: _withCtx((scope) => [
                                    _createElementVNode("p", null, _toDisplayString(scope.row.description) + ".", 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_el_table_column, {
                                label: "Materi/substansi wawancara (KUK)",
                                width: "auto",
                                "min-width": "400"
                            }, {
                                default: _withCtx((scope) => {
                                    var _a;
                                    return [
                                        ((_a = scope.row.details) === null || _a === void 0 ? void 0 : _a.length)
                                            ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.details, (item, index) => {
                                                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item.description), 1 /* TEXT */));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ];
                                }),
                                _: 1 /* STABLE */
                            })
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["data"])
            ];
        }),
        _: 1 /* STABLE */
    }));
}
